import React from "react";
import { Checkbox } from "@common/checkbox";
import { ResourceAvatar } from "@common/resourceAvatar";

import { Props } from "./types";
import styles from "./styles.scss";

function Resource({ resource, isSelected }: Props) {
  return (
    <div className={styles.resource}>
      <Checkbox isChecked={isSelected} />
      <div className={styles.avatar}>
        <ResourceAvatar resource={resource} />
      </div>
      <h3 className={styles.name}>{resource.name}</h3>
    </div>
  );
}

export { Resource };
